import { render, staticRenderFns } from "./ViewEmployees.vue?vue&type=template&id=5a648eed&scoped=true&"
import script from "./ViewEmployees.vue?vue&type=script&lang=js&"
export * from "./ViewEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmployees.vue?vue&type=style&index=0&id=5a648eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a648eed",
  null
  
)

export default component.exports